import React, { Component } from 'react';
import { STATUS, API, validateFields, Validation, Cookie, Urls } from '@vezeeta/web-utils';
import {
  Card,
  SignupStep,
  Button,
  Text,
  Caption,
  InputField,
  Icon,
  Spinner,
  COLORS,
  FONT_TYPES,
  FONT_WEIGHTS,
  IconsStore,
  Flex,
  Box,
} from '@vezeeta/web-components';
import { signIn } from '@vezeeta/web-sso';
import styled from 'styled-components';

import Icons from '@vezeeta/web-icons';

import { AppContainer } from '../App.style';
import { User, Clinic } from '../signup/_objects/_Objects';
import Navigator from '../../app/helpers/Navigator';
import {
  IsAlreadyLoggedInModalContainer,
  ModalBackground,
  ModalBox,
  WarningText,
  SubWarningText,
  SignupStepContainer,
  IllustratedInputsContainer,
  InputsContainer,
  PasswordInputContainer,
  StyledLink,
  ShowPassword,
} from './Login.style';

const Loading = styled.div`
  position: absolute;
  top: 6px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 99;
  display: none;
  justify-content: center;
  align-items: center;
`;

const InputFieldsContainer = styled(Box)`
  max-width: 395px;
  -webkit-box-flex: inherit;
  -webkit-flex-grow: inherit;
  -ms-flex-positive: inherit;
  flex-grow: inherit;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordInputType: 'password',
      showPasswordText: false,
      loginError: '',
      email: undefined,
      password: undefined,
    };
  }

  componentDidMount() {
    // Handle Enter key event to fire onSubmit to login
    document.onkeypress = e => {
      const event = e || window.event;
      const charCode = typeof event.which === 'number' ? event.which : event.keyCode;
      // Check if the key is Enter
      if (charCode === 13) {
        e.preventDefault();
        this.onSubmit();
      }
    };

    if (this.user.isAlreadyRegistered()) {
      if (Cookie.get(Cookie.SIGN_UP_STEP) !== 0 && Cookie.get(Cookie.SIGN_UP_STEP) !== undefined) {
        window.location.pathname = '/signup';
      } else {
        window.location = process.env.REACT_APP_SCHEDULE_URL;
      }
    }
    this.navigator.setPageTitle('Login to your account');
  }

  onLogin(response) {
    if (response.status === STATUS.SUCCESS || response.status === STATUS.CREATED) {
      if (response.data.SignUpStep === 0) {
        signIn(response.data.Token);
      } else {
        this.redirectToSignUp(
          response.data.AccountKey,
          response.data.ClinicKey,
          response.data.SignUpStep,
          response.data.Token,
        );
      }
    } else if (response.status === STATUS.NOT_FOUND || response.status === STATUS.NOT_AUTHORIZED) {
      this.setState(
        {
          loginError: 'Wrong Credentials',
        },
        () => {
          this.hideLoadingSpinner();
        },
      );
    } else {
      this.setState(
        {
          loginError: 'Error ocurred',
        },
        () => {
          this.hideLoadingSpinner();
          // TODO: log the error
        },
      );
    }
  }

  /**
   * Send user's data to the API and return with response
   */
  onSubmit = () => {
    const fields = [this.emailOrPhoneField, this.passwordField];

    const { isValid, firstDangerField } = validateFields(fields);

    if (!this.isAlreadyLoggedIn()) {
      if (isValid) {
        this.showLoadingSpinner();
        const signInHeader = {
          AccountIdentifier: this.emailOrPhoneField.getInputValue(),
          Password: this.passwordField.getInputValue(),
        };

        const registerAccount = new API();
        registerAccount
          .post(Urls.account.signIn, signInHeader)
          .then(response => {
            this.onLogin(response);
          })
          .catch(() => {
            // TODO: log the error
          });
      } else {
        fields[firstDangerField].focus();
      }
    }
  };

  setEmail = email => {
    this.setState({
      email,
    });
  };

  setPassword = password => {
    this.setState({
      password,
    });
  };

  isAlreadyLoggedIn = () => {
    if (Cookie.get(Cookie.TEMP_AUTH_TOKEN) || Cookie.get(Cookie.AUTH_TOKEN)) {
      this.showIsAlreadyLoggedInModal();
      setTimeout(() => {
        if (Cookie.get(Cookie.SIGN_UP_STEP) !== 0) {
          window.location.pathname = '/signup';
        } else {
          window.location = process.env.REACT_APP_SCHEDULE_URL;
        }
      }, 4000);

      return true;
    }
    return false;
  };

  navigator = Navigator.getInstance();
  user = User.getInstance();
  clinic = Clinic.getInstance();

  /**
   * Show loading spinner
   */
  showLoadingSpinner = () => {
    this.spinner.style.display = 'flex';
  };

  /**
   * Hide loading spinner
   */
  hideLoadingSpinner = () => {
    this.spinner.style.display = 'none';
  };

  /**
   * Toggle between showing/hiding password characters
   */
  toggleShowPassword = () => {
    this.setState({
      passwordInputType: !this.state.showPasswordText ? 'text' : 'password',
      showPasswordText: !this.state.showPasswordText,
    });
  };

  showIsAlreadyLoggedInModal = () => {
    const isAlreadyloggedElement = document.getElementById('isAlreadyloggedIn');
    isAlreadyloggedElement.style.display = 'block';
  };

  redirectToSignUp(accountKey, clinicKey, signUpStep, token) {
    this.user.setAccountKey(accountKey);
    this.user.setAccountToken(token);
    this.clinic.setClinicKey(clinicKey == null ? undefined : clinicKey);
    this.navigator.saveCookie(signUpStep - 1);
    this.user.saveCookie();
    if (clinicKey !== null) {
      this.clinic.saveCookie();
    }
    window.location.pathname = '/signup';
  }

  render() {
    let showPasswordIcon = null;
    if (this.state.showPasswordText) {
      showPasswordIcon = (
        <Icon
          icon={new IconsStore(Icons).getIcon('hidden_eye')}
          width={17}
          color={COLORS.PRIMARY_BLUE}
        />
      );
    } else {
      showPasswordIcon = (
        <Icon icon={new IconsStore(Icons).getIcon('eye')} width={17} color={COLORS.PRIMARY_BLUE} />
      );
    }

    return (
      <AppContainer py={5}>
        <Card overflow="hidden" minHeight="450px">
          <Flex py={12} flexDirection="column">
            <SignupStepContainer width={1}>
              <SignupStep title="Welcome Back!" hideBackButton />
            </SignupStepContainer>

            <Loading
              innerRef={spinner => {
                this.spinner = spinner;
              }}
            >
              <Spinner />
            </Loading>

            <IsAlreadyLoggedInModalContainer id="isAlreadyloggedIn">
              <ModalBackground>
                <ModalBox>
                  <WarningText>A user is already logged in!</WarningText>
                  <SubWarningText>Redirecting ...</SubWarningText>
                </ModalBox>
              </ModalBackground>
            </IsAlreadyLoggedInModalContainer>

            <IllustratedInputsContainer alignItems="center" justifyContent="center">
              <InputsContainer width={1}>
                <Flex flexDirection="row" alignItems="center" justifyContent="center">
                  <InputFieldsContainer>
                    <Box mb={4}>
                      <InputField
                        type="text"
                        value={this.state.email}
                        onChange={this.setEmail}
                        placeholder="Email"
                        icon={new IconsStore(Icons).getIcon('envelope')}
                        iconWidth={18}
                        validationChecks={Validation.email}
                        ref={inputField => {
                          this.emailOrPhoneField = inputField;
                        }}
                        isRequired
                      />
                    </Box>
                    <PasswordInputContainer>
                      <InputField
                        type={this.state.passwordInputType}
                        value={this.state.password}
                        onChange={this.setPassword}
                        placeholder="Password"
                        icon={new IconsStore(Icons).getIcon('lock')}
                        iconWidth={12}
                        ref={inputField => {
                          this.passwordField = inputField;
                        }}
                        isRequired
                        width="100%"
                      />
                      <ShowPassword
                        onClick={this.toggleShowPassword}
                        onKeyDown={() => {}}
                        ref={div => {
                          this.showPasswordIconContainer = div;
                        }}
                      >
                        {showPasswordIcon}
                      </ShowPassword>
                    </PasswordInputContainer>
                  </InputFieldsContainer>
                </Flex>

                <Flex flexDirection="column" alignItems="center" justifyContent="center">
                  <Text
                    mb={3}
                    color={COLORS.DANGER}
                    fontSize={FONT_TYPES.CAPTION}
                    fontWeight={FONT_WEIGHTS.NORMAL}
                  >
                    {this.state.loginError}
                  </Text>
                  <div>
                    <Button primary mt={2} color={COLORS.PRIMARY_BLUE} onClick={this.onSubmit}>
                      Login
                    </Button>
                  </div>
                </Flex>
                <Flex flexDirection="column" alignItems="center" justifyContent="center" mt={4}>
                  <Caption fontWeight={FONT_WEIGHTS.NORMAL}>
                    <StyledLink to="/forget-password" href="/forget-password">
                      Forgot your password?
                    </StyledLink>
                  </Caption>
                </Flex>

                <Flex flexDirection="row" alignItems="center" justifyContent="center" mt={4}>
                  <Caption fontWeight={FONT_WEIGHTS.NORMAL} color={COLORS.HELP_TEXT}>
              Don't have an account? {/* eslint-disable-line */}
                  </Caption>
                  <Caption>
                    <StyledLink to="/signup" href="/signup">
                      Sign up
                    </StyledLink>
                  </Caption>
                </Flex>
              </InputsContainer>
            </IllustratedInputsContainer>
          </Flex>
        </Card>
      </AppContainer>
    );
  }
}

export default Login;
